import { render, staticRenderFns } from "./TableInvoiceReceipts.vue?vue&type=template&id=1bde31a8&scoped=true"
import script from "./TableInvoiceReceipts.vue?vue&type=script&lang=ts"
export * from "./TableInvoiceReceipts.vue?vue&type=script&lang=ts"
import style0 from "./TableInvoiceReceipts.vue?vue&type=style&index=0&id=1bde31a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde31a8",
  null
  
)

export default component.exports